import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './akatypes';

declare const window: Window;
const jQuery = window.jQuery;

// const consolelog = console.log;
const consolelog = function foo(x?: any) {};

export function urlPathname() {
  const url = new URL(window.location.href);
  return url.pathname;
}

export function getUrlParameter(sParam: string) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}

export function alertCtkOKFunction(text: string, okFunction: FunctionHandler) {
  // https://gasparesganga.com/labs/jquery-message-box/
  jQuery
    .MessageBox({
      input: false,
      message: text,
      customClass: 'messagebox--custom',
      buttonDone: {
        ano: {
          text: 'OK',
          customClass: 'messagebox__button--done',
        },
      }, // String / Object / Boolean
    })
    .done(function (data: string, button: string) {
      // Check data and button values
      consolelog(data);
      consolelog(button);
      okFunction();
    });
}

export function alertCtk(text: string) {
  // https://gasparesganga.com/labs/jquery-message-box/
  try {
    jQuery
      .MessageBox({
        input: false,
        message: text,
        customClass: 'messagebox--custom',
        buttonDone: {
          ano: {
            text: 'OK',
            customClass: 'messagebox__button--done',
          },
        }, // String / Object / Boolean
      })
      .done(function (data: string, button: string) {
        // Check data and button values
        consolelog(data);
        consolelog(button);
      });
  } catch (err) {
    consolelog('err: ' + err);
  }
}
export function alertCtkApiError() {
  alertCtk(
    'Stránky jsou momentálně nedostupné, zkuste provést akci později nebo nás kontaktujte na e-mailu shop@ctk.cz',
  );
}

export function confirmCtkButtons(
  text: string,
  ano: string,
  ne: string,
  okFunction: FunctionHandler,
  cancelFunction: FunctionHandler,
) {
  // https://gasparesganga.com/labs/jquery-message-box/
  jQuery
    .MessageBox({
      input: false,
      message: text,
      buttonDone: {
        ano: {
          text: ano,
          customClass: 'messagebox__button--done',
        },
      }, // String / Object / Boolean
      buttonFail: {
        ne: {
          text: ne,
          customClass: 'messagebox__button--fail',
        },
      }, // String / Object / Boolean
      buttonsOrder: 'done fail',
      customClass: 'messagebox--custom',
    })
    .done(function (data: string, button: string) {
      // Check data and button values
      consolelog(data);
      consolelog(button);
      okFunction();
    })
    .fail(function (data: string, button: string) {
      // Check data and button values
      consolelog(data);
      consolelog(button);
      if (cancelFunction) {
        cancelFunction();
      }
    });
}
export function confirmCtk(
  text: string,
  okFunction: FunctionHandler,
  cancelFunction: FunctionHandler,
) {
  // https://gasparesganga.com/labs/jquery-message-box/
  confirmCtkButtons(text, 'Ano', 'Ne', okFunction, cancelFunction);
}

export function fillCountries() {
  const countries = [
    'Česká republika',
    'Slovenská republika',
    'Afghánistán',
    'Ålandy',
    'Albánie',
    'Alžírsko',
    'Americká Samoa',
    'Americké Panenské ostrovy',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarktida',
    'Antigua a Barbuda',
    'Argentina',
    'Arménie',
    'Aruba',
    'Austrálie',
    'Ázerbájdžán',
    'Bahamy',
    'Bahrajn',
    'Bangladéš',
    'Barbados',
    'Belgie',
    'Belize',
    'Bělorusko',
    'Benin',
    'Bermudy',
    'Bhútán',
    'Bolívie',
    'Bosna a Hercegovina',
    'Botswana',
    'Bouvetův ostrov',
    'Brazílie',
    'Britské indickooceánské území',
    'Britské Panenské ostrovy',
    'Brunej',
    'Bulharsko',
    'Burkina Faso',
    'Burundi',
    'Cookovy ostrovy',
    'Čad',
    'Černá Hora',
    'Čína',
    'Dánsko',
    'Demokratická republika Kongo',
    'Dominika',
    'Dominikánská republika',
    'Džibutsko',
    'Egypt',
    'Ekvádor',
    'Eritrea',
    'Estonsko',
    'Etiopie',
    'Faerské ostrovy',
    'Falklandy (Malvíny)',
    'Fidži',
    'Filipíny',
    'Finsko',
    'Francie',
    'Francouzská Guyana',
    'Francouzská jižní a antarktická území',
    'Francouzská Polynésie',
    'Gabon',
    'Gambie',
    'Ghana',
    'Gibraltar',
    'Grenada',
    'Grónsko',
    'Gruzie',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heardův ostrov a McDonaldovy ostrovy',
    'Honduras',
    'Hongkong',
    'Chile',
    'Chorvatsko',
    'Indie',
    'Indonésie',
    'Irák',
    'Írán',
    'Irsko',
    'Island',
    'Itálie',
    'Izrael',
    'Jamajka',
    'Japonsko',
    'Jemen',
    'Jersey',
    'Jihoafrická republika',
    'Jižní Georgie a Jižní Sandwichovy ostrovy',
    'Jižní Korea',
    'Jordánsko',
    'Kajmanské ostrovy',
    'Kambodža',
    'Kamerun',
    'Kanada',
    'Kapverdy',
    'Katar',
    'Kazachstán',
    'Keňa',
    'Kiribati',
    'Kokosové ostrovy',
    'Kolumbie',
    'Komory',
    'Kongo',
    'Kostarika',
    'Kuba',
    'Kuvajt',
    'Kypr',
    'Kyrgyzstán',
    'Laos',
    'Lesotho',
    'Libanon',
    'Libérie',
    'Libye',
    'Lichtenštejnsko',
    'Litva',
    'Lotyšsko',
    'Lucembursko',
    'Macao',
    'Madagaskar',
    'Maďarsko',
    'Makedonie',
    'Malajsie',
    'Malawi',
    'Maledivy',
    'Mali',
    'Malta',
    'Man',
    'Maroko',
    'Marshallovy ostrovy',
    'Martinik',
    'Mauricius',
    'Mauritánie',
    'Mayotte',
    'Menší odlehlé ostrovy USA',
    'Mexiko',
    'Mikronésie',
    'Moldavsko',
    'Monako',
    'Mongolsko',
    'Montserrat',
    'Mosambik',
    'Myanmar',
    'Namibie',
    'Nauru',
    'Německo',
    'Nepál',
    'Niger',
    'Nigérie',
    'Nikaragua',
    'Niue',
    'Nizozemské Antily',
    'Nizozemsko',
    'Norfolk',
    'Norsko',
    'Nová Kaledonie',
    'Nový Zéland',
    'Omán',
    'Pákistán',
    'Palau',
    'Palestina',
    'Panama',
    'Papua-Nová Guinea',
    'Paraguay',
    'Peru',
    'Pitcairn',
    'Pobřeží slonoviny',
    'Polsko',
    'Portoriko',
    'Portugalsko',
    'Rakousko',
    'Réunion',
    'Rovníková Guinea',
    'Rumunsko',
    'Rusko',
    'Rwanda',
    'Řecko',
    'Saint Pierre a Miquelon',
    'Salvador',
    'Samoa',
    'San Marino',
    'Saúdská Arábie',
    'Senegal',
    'Severní Korea',
    'Severní Mariany',
    'Seychely',
    'Sierra Leone',
    'Singapur',
    'Slovinsko',
    'Somálsko',
    'Spojené arabské emiráty',
    'Spojené státy americké',
    'Srbsko',
    'Středoafrická republika',
    'Súdán',
    'Surinam',
    'Svalbard a Jan Mayen',
    'Svatá Helena',
    'Svatá Lucie',
    'Svatý Kryštof a Nevis',
    'Svatý Tomáš a Princův ostrov',
    'Svatý Vincenc a Grenadiny',
    'Svazijsko',
    'Sýrie',
    'Šalamounovy ostrovy',
    'Španělsko',
    'Šrí Lanka',
    'Švédsko',
    'Švýcarsko',
    'Tádžikistán',
    'Tanzanie',
    'Thajsko',
    'Tchaj-wan',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad a Tobago',
    'Tunisko',
    'Turecko',
    'Turkmenistán',
    'Turks a Caicos',
    'Tuvalu',
    'Uganda',
    'Ukrajina',
    'Uruguay',
    'Uzbekistán',
    'Vánoční ostrov',
    'Vanuatu',
    'Vatikán',
    'Velká Británie',
    'Venezuela',
    'Vietnam',
    'Východní Timor',
    'Wallis a Futuna',
    'Zambie',
    'Západní Sahara',
    'Zimbabwe',
  ];
  jQuery('#formcountry').append(
    countries
      .map((it) => '<option value="' + it + '">' + it + '</option>')
      .join(' '),
  );
}
